import { useAuth } from 'context/auth'
import { ROLE } from 'enums/user'
import AuthRoutes from './auth-routes'
import OnboardOrganisationRoutes from './onboard-organisation-routes'
import OrganisationRoutes from './organisation-routes'
import PublicRoutes from './public-routes'
import UnauthorizedRoutes from './unauthorized-routes'

const Routes = () => {
  const { currentUser } = useAuth()
  const routes = PublicRoutes

  // PUBLIC
  if (!currentUser) return routes.concat(AuthRoutes)

  // ONBOARD ORGANISATION
  if (!currentUser.account || currentUser.onBoardingStep < 3)
    return routes.concat(OnboardOrganisationRoutes)

  // EMAIL VERIFICATION
  // if (!currentUser.verified)
  // return EmailVerificationRoutes(currentUser.verificationEmailSent)

  // UNAUTHORIZED ACCESS
  if (currentUser.role !== ROLE.SUPER_ADMIN)
    return routes.concat(UnauthorizedRoutes)

  // ORGANISATION ACCOUNT
  if (currentUser.role === ROLE.SUPER_ADMIN)
    return routes.concat(OrganisationRoutes)

  // Default fallback
  return routes
}

export default Routes
